// @flow
import React from 'react';
import classNames from 'classnames';
import ReactDropdown from 'react-dropdown';
import type { DropdownOption } from 'components/molecules/formDropdown';
import 'react-dropdown/style.css';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  locations: Array<DropdownOption>,
  value?: number | string,
  onSelect: (id: number | string) => void,
  mode: 'light' | 'dark',
  placeholder?: string,
  className?: string,
};

export const LocationDropdown = (props: Props) => {
  const {
    locations,
    value,
    onSelect,
    mode,
    placeholder = 'Locations',
    className = '',
  } = props;

  const containerClass = classNames(
    'location-dropdown normal-scroll',
    className,
    mode
  );

  const selectedOption =
    value && value !== ''
      ? locations.find(location => location.value === value)
      : null;

  return (
    <div className={containerClass}>
      <ReactDropdown
        placeholder={placeholder}
        id={'location-dropdown'}
        name={'location'}
        options={locations}
        value={selectedOption}
        onChange={onSelect}
        arrowClosed={<span className="arrow-closed" />}
        arrowOpen={<span className="arrow-open" />}
      />
    </div>
  );
};
